jQuery(document).ready(function ($) {
    const intro_galleries = $('.intro__gallery');

    intro_galleries.each(function () {
        const $gallery = $(this);
        const $current = $gallery.find('.intro__gallery--counter .current');

        const update_counter = function (swiper) {
            const slide_number = swiper.realIndex + 1;

            $current.text(String(slide_number).padStart(2, '0'));
        };

        const single_gallery = new Swiper(`#${$gallery.attr('id')}`, {
            loop: true,
            loopAdditionalSlides: 2,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            centeredSlides: true,

            spaceBetween: 12,

            grabCursor: true,

            autoplay: {
                delay: 8000
            },

            navigation: {
                prevEl: '.intro__gallery--prev',
                nextEl: '.intro__gallery--next'
            },

            on: {
                init: update_counter,
                slideChange: update_counter
            },

            breakpoints: {
                480: {
                    spaceBetween: 32
                }
            }
        });
    });
});